import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M12 14v7","key":"svg-1"}],["path",{"d":"M9 18h6","key":"svg-2"}]]

const IconGenderFemale = createReactComponent('outline', 'gender-female', 'GenderFemale', __iconNode);

export default IconGenderFemale;